const isPermissionError = (error: string) => error.toString().includes('Permission denied');

export default isPermissionError;
